String.prototype.format = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
};

String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, "");
};

String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
String.prototype.startsWith = function (str) {
    return this.indexOf(str) == 0;
};

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.cleanup = function () {
    return this.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");
};

Date.prototype.stdTimezoneOffset = function () {
    var jan = new Date(this.getFullYear(), 0, 1);
    var jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

if (!Date.prototype.toISOString) {
    Date.prototype.toISOString = function () {
        function pad(n) {
            return n < 10 ? "0" + n : n;
        }
        return (
            this.getUTCFullYear() +
            "-" +
            pad(this.getUTCMonth() + 1) +
            "-" +
            pad(this.getUTCDate()) +
            "T" +
            pad(this.getUTCHours()) +
            ":" +
            pad(this.getUTCMinutes()) +
            ":" +
            pad(this.getUTCSeconds()) +
            "Z"
        );
    };
}

var oldMouseStart = $.ui.draggable.prototype._mouseStart;
$.ui.draggable.prototype._mouseStart = function (event, overrideHandle, noActivation) {
    this._trigger("beforeStart", event, this._uiHash());
    oldMouseStart.apply(this, [event, overrideHandle, noActivation]);
};

Math.roundTo = function (number, precision) {
    precision = Math.abs(precision) || 1;
    return Math.round(number / precision) * precision;
};

String.prototype.isToday = function () {
    return moment(this.toString()).isSame(new Date(), "day");
};

!(function (a, b) {
    function c(c, j, k) {
        var n = [];
        j = 1 == j ? { entropy: !0 } : j || {};
        var s = g(f(j.entropy ? [c, i(a)] : null == c ? h() : c, 3), n),
            t = new d(n),
            u = function () {
                for (var a = t.g(m), b = p, c = 0; q > a; ) ((a = (a + c) * l), (b *= l), (c = t.g(1)));
                for (; a >= r; ) ((a /= 2), (b /= 2), (c >>>= 1));
                return (a + c) / b;
            };
        return (
            (u.int32 = function () {
                return 0 | t.g(4);
            }),
            (u.quick = function () {
                return t.g(4) / 4294967296;
            }),
            (u["double"] = u),
            g(i(t.S), a),
            (
                j.pass ||
                k ||
                function (a, c, d, f) {
                    return (
                        f &&
                            (f.S && e(f, t),
                            (a.state = function () {
                                return e(t, {});
                            })),
                        d ? ((b[o] = a), c) : a
                    );
                }
            )(u, s, "global" in j ? j.global : this == b, j.state)
        );
    }
    function d(a) {
        var b,
            c = a.length,
            d = this,
            e = 0,
            f = (d.i = d.j = 0),
            g = (d.S = []);
        for (c || (a = [c++]); l > e; ) g[e] = e++;
        for (e = 0; l > e; e++) ((g[e] = g[(f = s & (f + a[e % c] + (b = g[e])))]), (g[f] = b));
        (d.g = function (a) {
            for (var b, c = 0, e = d.i, f = d.j, g = d.S; a--; )
                ((b = g[(e = s & (e + 1))]),
                    (c = c * l + g[s & ((g[e] = g[(f = s & (f + b))]) + (g[f] = b))]));
            return ((d.i = e), (d.j = f), c);
        })(l);
    }
    function e(a, b) {
        return ((b.i = a.i), (b.j = a.j), (b.S = a.S.slice()), b);
    }
    function f(a, b) {
        var c,
            d = [],
            e = typeof a;
        if (b && "object" == e)
            for (c in a)
                try {
                    d.push(f(a[c], b - 1));
                } catch (g) {}
        return d.length ? d : "string" == e ? a : a + "\0";
    }
    function g(a, b) {
        for (var c, d = a + "", e = 0; e < d.length; )
            b[s & e] = s & ((c ^= 19 * b[s & e]) + d.charCodeAt(e++));
        return i(b);
    }
    function h() {
        try {
            if (j) return i(j.randomBytes(l));
            var b = new Uint8Array(l);
            return ((k.crypto || k.msCrypto).getRandomValues(b), i(b));
        } catch (c) {
            var d = k.navigator,
                e = d && d.plugins;
            return [+new Date(), k, e, k.screen, i(a)];
        }
    }
    function i(a) {
        return String.fromCharCode.apply(0, a);
    }
    var j,
        k = this,
        l = 256,
        m = 6,
        n = 52,
        o = "random",
        p = b.pow(l, m),
        q = b.pow(2, n),
        r = 2 * q,
        s = l - 1;
    if (((b["seed" + o] = c), g(b.random(), a), "object" == typeof module && module.exports)) {
        module.exports = c;
        try {
            j = require("crypto");
        } catch (t) {}
    } else
        "function" == typeof define &&
            define.amd &&
            define(function () {
                return c;
            });
})([], Math);

(function ($) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function (str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };
    $.parseParams = function (query) {
        var params = {},
            e;
        while ((e = re.exec(query))) {
            var k = decode(e[1]),
                v = decode(e[2]);
            if (k.substring(k.length - 2) === "[]") {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            } else params[k] = v;
        }
        return params;
    };
})(jQuery);
